export default {
      id: "ic_figure-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#ic_figure",
      toString: function () {
        return this.url;
      }
    }